"use client";

import React from "react";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Neural-driven architectures that optimize performance and scalability for modern web applications.", "Seamless integration of intelligent automation into user-centric digital experiences.", "High-precision code migration ensuring data integrity and future-proof technology stacks."];
export default function TheScienceOfMyLight() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="108718" id="the-essence-of-ai" className="w-full bg-background text-foreground overflow-hidden">
      <div className="flex flex-col lg:flex-row w-full min-h-[600px] lg:min-h-[700px]">
        
        {}
        <div className="w-full lg:w-[60%] bg-background flex items-center justify-center p-8 sm:p-12 md:p-16 lg:p-24 xl:p-32 relative z-10">
          <div ref={contentRef} className={`max-w-2xl w-full transition-all duration-1000 ease-out transform ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <span className="text-xs sm:text-sm font-bold tracking-[0.2em] text-primary uppercase mb-6 block">
              The Innovation
            </span>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-bold text-chart-3 mb-10 leading-[1.2] tracking-tight">
              The Essence of AI
            </h2>
            
            <ul className="space-y-8">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-5 group">
                  <div className="mt-1 bg-primary/10 p-1.5 rounded-sm shrink-0 transition-colors duration-300 group-hover:bg-primary/20">
                    <Check className="w-5 h-5 text-primary" strokeWidth={3} />
                  </div>
                  <p className="text-lg sm:text-xl text-foreground/90 leading-relaxed font-sans">
                    {benefit}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`w-full lg:w-[40%] relative min-h-[500px] lg:min-h-auto bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605214/img/red_light_therapy_lifestyle_session.png)] transition-opacity duration-1000 ease-in ${isImageVisible ? "opacity-100" : "opacity-0"}`}>
          {}
          <div className="absolute left-0 top-0 bottom-0 w-14 sm:w-16 bg-primary flex flex-col items-center justify-between py-12 z-20 shadow-none">
            
            {}
            <div className="grid grid-cols-3 gap-1.5 opacity-30">
              {[...Array(15)].map((_, i) => <div key={`top-dot-${i}`} data-index={i} className="w-1 h-1 bg-primary-foreground rounded-full" />)}
            </div>

            {}
            <div className="flex-1 flex items-center justify-center">
              <span className="-rotate-90 whitespace-nowrap text-primary-foreground font-sans font-bold tracking-[0.25em] text-sm sm:text-base uppercase">
                MigratePro
              </span>
            </div>

            {}
            <div className="grid grid-cols-3 gap-1.5 opacity-30">
              {[...Array(15)].map((_, i) => <div key={`bottom-dot-${i}`} data-index={i} className="w-1 h-1 bg-primary-foreground rounded-full" />)}
            </div>
            
          </div>
          
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-black/5 to-transparent pointer-events-none" />
        </div>

      </div>
    </section>;
}